/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Rule_Upper_CaseInputs */



/**
* | output |
* | --- |
* | "Password contains an uppercase letter (A-Z)" |
*
* @param {Password_Rule_Upper_CaseInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const password_rule_upper_case = /** @type {((inputs?: Password_Rule_Upper_CaseInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Rule_Upper_CaseInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Password contains an uppercase letter (A-Z)")
	return /** @type {LocalizedString} */ ("Le mot de passe contient une majuscule (A-Z)")
});